import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth.js'
import cart from './modules/cart.js'
import tests from './modules/tests.js';
import order from './modules/order.js';
import testPrototype from './modules/testPrototype.js';
import taskDevice from './modules/taskDevice.js';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth: {
      namespaced: true,
      ...auth
    },
    cart: {
      namespaced: true,
      ...cart
    },
    tests: {
      namespaced: true,
      ...tests
    },
    order: {
      namespaced: true,
      ...order
    },
    testPrototype,
    taskDevice: {
      namespaced: true,
      ...taskDevice,
    },
  },
  strict: import.meta.env.NODE_ENV !== 'production'
})
